import Ajax from '../common/ajax'

export default {
  model: 'base',
  getPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/page`, queryParam)
  },
  getRolePage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/pageByRole`, queryParam)
  },
  getList (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/list`, queryParam)
  },
  getInfo (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/info/${id}`)
  },
  add (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/add`, data)
  },
  edit (data = {}) {
    return Ajax.put(`/api/gradeMaster/v1/${this.model}/update`, data)
  },
  del (id) {
    return Ajax.del(`/api/gradeMaster/v1/${this.model}/delete/${id}`)
  },
  disable (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/updateDisable/${id}`)
  },
  enable (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/updateDisable/${id}`)
  },
  publish (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/publish/${id}`)
  },
  unPublish (id) {
    return Ajax.get(`/api/gradeMaster/v1/${this.model}/unpublish/${id}`)
  },
  getCalc (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/v1/${this.model}/calc`, queryParam)
  }
}
